import axios from "axios";
import { createContext, useContext, useReducer } from "react";
import Basic_reducer from "../reducer/Basic_reducer";
import {
  GET_COUNTRY_BEGIN,
  GET_COUNTRY_SUCCESS,
  GET_COUNTRY_ERROR,
  GET_STATE_BEGIN,
  GET_STATE_SUCCESS,
  GET_STATE_ERROR,
  GET_CITY_BEGIN,
  GET_CITY_SUCCESS,
  GET_CITY_ERROR,
} from "../utils/action";
import {
  ACCEPT_HEADER,
  get_country_url,
  get_state_url,
  get_city_url,
} from "../utils/constant";

const BasicContext = createContext();

const initialState = {
  get_country_loading: false,
  get_country_data: [],
  get_state_loading: false,
  get_state_data: [],
  get_city_loading: false,
  get_city_data: [],
};

export const BasicProvider = ({ children }) => {
  const [state, dispatch] = useReducer(Basic_reducer, initialState);

  // ─── GET COUNTRY ─────────────────────────────────────────────────────────
  const GetCountry = async () => {
    dispatch({ type: GET_COUNTRY_BEGIN });

    axios
      .get(get_country_url, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({ type: GET_COUNTRY_SUCCESS, payload: res.data.data });
        } else {
          dispatch({ type: GET_COUNTRY_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Country Api ", err);
        dispatch({ type: GET_COUNTRY_ERROR });
      });
  };

  // ─── GET STATE ───────────────────────────────────────────────────────────
  const GetState = async (countryId) => {
    dispatch({ type: GET_STATE_BEGIN });

    const formdata = new FormData();
    if (countryId !== undefined && countryId !== null) {
      formdata.append("country_id", countryId);
    }

    axios
      .post(get_state_url, formdata, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({ type: GET_STATE_SUCCESS, payload: res.data.data });
        } else {
          dispatch({ type: GET_STATE_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get State Api ", err);
        dispatch({ type: GET_STATE_ERROR });
      });
  };

  // ─── GET CITY ────────────────────────────────────────────────────────────
  const GetCity = async (stateId) => {
    dispatch({ type: GET_CITY_BEGIN });

    const formdata = new FormData();
    if (stateId !== undefined && stateId !== null) {
      formdata.append("state_id", stateId);
    }

    axios
      .post(get_city_url, formdata, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({ type: GET_CITY_SUCCESS, payload: res.data.data });
        } else {
          dispatch({ type: GET_CITY_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get City Api ", err);
        dispatch({ type: GET_CITY_ERROR });
      });
  };

  return (
    <BasicContext.Provider
      value={{
        ...state,
        GetCountry,
        GetState,
        GetCity,
      }}
    >
      {children}
    </BasicContext.Provider>
  );
};

export const useBasicContext = () => {
  return useContext(BasicContext);
};
